import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/styles.scss';export default {
  "addPlanzoneResourceToProjects": "_addPlanzoneResourceToProjects_1h9xr_1",
  "body": "_body_1h9xr_11",
  "header": "_header_1h9xr_21",
  "col": "_col_1h9xr_27",
  "filterContainer": "_filterContainer_1h9xr_36",
  "footer": "_footer_1h9xr_50",
  "roleInput": "_roleInput_1h9xr_61"
};